import { Box } from '@mui/material';
import RaterOptionsInput from '../../../../components/RaterOptionsInput';
import { useUnderwriterContext } from '../../provider/UnderwriterProvider';
import { isUnderwriterContext } from '../../types';

const UwRaterOptions = () => {
  const context = useUnderwriterContext();

  if (!isUnderwriterContext(context)) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '1rem',
      }}
    >
      <RaterOptionsInput
        label=" "
        name="productVersion"
        options={context.state.raterOptions.productVersion.options}
        value={context.state.raterOptions.productVersion.value}
      />
    </Box>
  );
};

export default UwRaterOptions;
